import { toDate, toAnalogueTime } from '../../utilities/date';
import './styles.css';
import { alarmsDTO, UpdateUserAlarmsData,UpdateAlarmRequest} from "./tenantApiCalls";
interface timeslotIntervals   {
    displayName  : string,
    value: number
}
type alarmInfoProp = {
    divRef: React.LegacyRef<HTMLDivElement>;
    positionX: number;
    positionY: number;
    slots: timeslotIntervals[];
    alarmData:alarmsDTO;
    onClose: () => void;
}
function TimeSlots(props:alarmInfoProp) {

    function Action(interval:number){
        const currentTime = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        currentTime.setMinutes(currentTime.getMinutes() + interval)
        let updateAlarmRequest:UpdateAlarmRequest={
        AlarmAt : currentTime,
        Subject : props.alarmData.subject,
        Notes:props.alarmData.notes
        } 
        UpdateUserAlarmsData(props.alarmData.id,updateAlarmRequest);
        props.onClose()
    }

  return (
    <div className="SnoozeList" style={{ top:props.positionY + 20 , left: props.positionX-120}}  ref={props.divRef}>   
        <ul>
            <li><button style={{fontWeight:"bold"}}> Snooze</button></li>
            {props.slots.map((slot, index) => (
            <li key={index}  >
                <button onClick={e=>{Action(slot.value)}} >{slot.displayName}</button> 
            </li>
            ))}
        </ul>
    </div>
    );
}
export default TimeSlots;